import type { ButtonProps, ButtonRef } from "./button.types";
import { buttonStyles } from "./button.styles";

export function Button<T extends React.ElementType = "button">(
  props: ButtonProps<T> & { ref?: React.Ref<ButtonRef<T>> },
) {
  const {
    children,
    variant = "primary",
    tone = "default",
    size = "m",
    icon,
    className,
    as = "button" as T,
    disabled = false,
    ref,
    ...rest
  } = props;

  const classes = buttonStyles({
    variant,
    size,
    className,
    disabled,
    tone,
  });

  const Component = as;

  const componentProps = {
    ...rest,
  };

  if (as === "button" || !as) {
    (componentProps as any).disabled = disabled;
  } else if (as === "a" && disabled) {
    (componentProps as any)["aria-disabled"] = true;
    (componentProps as any).onClick = (e: React.MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();
    };
  }

  return (
    <Component ref={ref} className={classes} {...componentProps}>
      {children}
      {icon ?? null}
    </Component>
  );
}

Button.displayName = "Button";
